module.exports = __webpack_public_path__ + "img/deworming.e7bf5348.png";